import { IAnyObjectType } from "../../widgets/components/SelectionBox";
import { IGuide } from "../../widgets/interfaces/model/Guides";
import { ICanvasEditorState, IGuideState, INonUndoableAction } from "../../widgets/interfaces/model/index";

/**
 * Set guide line action interface
 */
export interface ISetGuidesAction extends INonUndoableAction {
    guides: IGuide[];
};

/**
 * Reset guides action interface
 */
export interface IResetGuidesAction extends INonUndoableAction {
};

/**
 * Set guide snapped details action interface.
 */
export interface ISetGuideSnapAction extends INonUndoableAction {
    snapDetails: IAnyObjectType;
};

/**
 * Set guides
 * It will replace all existing guides
 * @param state Current state for Guides reducer
 * @param action Reducer payload to set guide line
 * @param action.type Set Guides action type viz. 'SET_GUIDES'
 * @param action.guides The Guides to set
 * @returns New state for Guides reducer
 */
export const setGuides = (state: ICanvasEditorState["guides"], action: ISetGuidesAction): IGuideState => {
	const newState: ICanvasEditorState["guides"] = { ...state };
	newState.guides = action.guides;
	return newState;
};

/**
 * Reset guides
 * It will replace all existing guides with empty array
 * @param state Current state for Guides reducer
 * @param action Reducer payload to set guide line
 * @param action.type Set Guides action type viz. 'RESET_GUIDES'
 * @returns New state for Guides reducer
 */
export const resetGuides = (state: ICanvasEditorState["guides"], action: IResetGuidesAction): IGuideState => {
	const newState: ICanvasEditorState["guides"] = { ...state };
	newState.guides = [];
	return newState;
};

/**
 * Set guide snapped details
 * @param state Current state for canvas editor reducer
 * @param action Reducer payload to set guide snap details
 * @returns New state for Canvas editor reducer
 */
export const setGuideSnapDetails =
(state: ICanvasEditorState["guides"], action: ISetGuideSnapAction) => {
	const newState: ICanvasEditorState["guides"] = { ...state };
	newState.snapXToGuides = action.snapDetails.snapXToGuides;
	newState.snapYToGuides = action.snapDetails.snapYToGuides;
	return newState;
};
